module.exports = __webpack_public_path__ + "img/11088029_L.a55def92.png";